import { DispatchSelection } from 'src/components/dispatch/detailPanel/DispatchDetailPanel';
import { ExpandedStopVM } from 'src/components/dispatch/vehicleRowExpand/buildExpandedRowVM';
import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 展開行の停車地クリック → DispatchSelection。解決できなければ null。
 *
 * rowId → row は rowLookup.ts の buildRowLookup と同じ探索だが、あちらは
 * `Map<string, VehicleRowGroup['rows'][number]>` で Vehicle を持たない。
 * DispatchSelection の 'vehicle' 分岐は vehicle が必須のため使い回せず、
 * ここでは rowGroups を直接走査して vehicle も一緒に取り出す。
 */
export function resolveSelectionFromStop(
  rowId: string,
  stop: Pick<ExpandedStopVM, 'cardIndex' | 'dispatchOrderIndex'>,
  rowGroups: VehicleRowGroup[],
): DispatchSelection {
  for (const group of rowGroups) {
    const row = group.rows.find((r) => r.rowId === rowId);
    if (!row) continue;
    const card = row.cards[stop.cardIndex];
    if (!card) return null;
    return { source: 'vehicle', card, vehicle: group.vehicle, orderIndex: stop.dispatchOrderIndex };
  }
  return null;
}
